exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/*登陆整个背景*/\n    .login-wrap{\n        background: #fff;\n    }\n    /*商家后台头部背景颜色*/\n    .login_head{\n    \tbackground:#fff;\n    }\n    /*中部背景*/\n    .login_box{\n        background:#00c;\n    }\n    /*底部背景*/\n    .login_bottom{\n    \tbackground:#fff;\n    }\n\n\n\n\n\n.header{\n    background-color: #242f42;\n}\n\n.plugins-tips{\n    background: #eef1f6;\n}\n.plugins-tips a{\n    color: #20a0ff;\n}\n.el-upload--text em {\n    color: #20a0ff;\n}\n.pure-button{\n    background: #20a0ff;\n}\n\n\n.login_box{\n    background-color: #324157;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./static/css/color-background.css
// module id = 7bVv
// module chunks = 212